module.exports = {"pagination":{}}


//////////////////
// WEBPACK FOOTER
// ./~/aws-sdk/apis/forecastquery-2018-06-26.paginators.json
// module id = 1262
// module chunks = 0